import { Phone } from "lucide-react";
import { SITE } from "@/lib/siteData";

export default function StickyEmergencyCTA() {
  return (
    <a
      href={SITE.phoneTel}
      className="fixed bottom-6 right-6 z-40 group"
      data-testid="sticky-emergency-cta"
      aria-label="Dépannage d'urgence"
    >
      <div className="flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl shadow-red-600/40 transition-all hover:scale-105">
        <span className="relative flex w-3 h-3">
          <span className="animate-ping absolute inline-flex w-full h-full rounded-full bg-white opacity-75" />
          <span className="relative inline-flex rounded-full w-3 h-3 bg-white" />
        </span>
        <Phone className="w-5 h-5" />
        <div className="text-left leading-tight hidden sm:block">
          <div className="text-[10px] uppercase tracking-wider font-semibold opacity-80">Urgence</div>
          <div className="text-sm font-bold">Dépannage</div>
        </div>
      </div>
    </a>
  );
}
